<template>
  <div class="pdt-20px column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('editionCreationDepenseBailleur.editionLignesCommandes.title')}}
        </p>
      </header>
      <div class="card-content">
        <div
          v-for="ligneCommande in dcf.lignesCommande"
          :key="ligneCommande.id">
          <app-ligne-normale
            v-if="ligneCommande.type === constantes.NORMAL"
            class="has-background-table-second-color mgb-25px"
            :sens="sens"
            :societe-id="$route.params.id ? devisCommande.societeId : societeActiveId"
            :ligne-commande="ligneCommande" />
          <template v-if="ligneCommande.type === constantes.REGROUPEMENT">
            <div
              v-for="ligne in ligneCommande.lignesCommande"
              :key="ligne.id">
              <app-ligne-normale
                v-if="ligne.type === constantes.NORMAL"
                class="has-background-table-second-color mgb-25px"
                :sens="sens"
                :societe-id="$route.params.id ? devisCommande.societeId : societeActiveId"
                :ligne-commande="ligne" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import appLigneNormale from '@/components/factures/ligneFactureModifProduit/ligneCommandeProduitNormal';
import { NORMAL, REGROUPEMENT } from '@/configuration/devisConf';

const Societes = createNamespacedHelpers('societe');

export default {
  props: {
    dcf: {
      required: true,
      type: Object,
    },
    sens: {
      type: String,
      required: true,
    },
    devisCommande: {
      type: Object,
      required: true,
    },
  },
  components: {
    appLigneNormale,
  },
  computed: {
    ...Societes.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  data() {
    return {
      constantes: {
        NORMAL,
        REGROUPEMENT,
      },
    };
  },
};
</script>
